import React from "react";

const ContaDelete = () => {
  return <h1>Customer Delete</h1>;
};

export default ContaDelete;
